module.exports = __webpack_public_path__ + "img/mb-marker-active-128.6a72fd9b.png";